import { TriangleAlert } from "lucide-react";
import { fristKurz } from "../format";

// W82 Web-7, Nachzügler 2: Anzahl im Gruppenkopf und Fälligkeit als Wort, geteilt von der Startseite und der Seite „Aufgaben“
// (aus Posteingang.tsx hierher verschoben, unverändert)

export function Anzahl(props: { n: number }) {
  return <span className="gruppe-anzahl font-medium text-pg-text-2">{props.n}</span>;
}

/** Frist als Wort statt Chip: ueberfaellig in --pg-danger mit Symbol (nie nur Farbe), sonst normal. */
export function FristWort(props: { datum: string }) {
  const { text, ueberfaellig } = fristKurz(props.datum);
  return (
    <span className={`frist-badge t-footnote t-zahl inline-flex items-center gap-1 whitespace-nowrap ${ueberfaellig ? "font-semibold text-pg-danger" : "text-pg-text-2"}`}>
      {ueberfaellig && <TriangleAlert size={14} strokeWidth={2} aria-hidden />}
      {ueberfaellig && <span className="sr-only">Überfällig </span>}
      {text}
    </span>
  );
}
